const splideOptions = {
  type: 'slide',
  drag: true,
  gap: 21,
  fixedWidth: 290,
  rewind: false,
  pagination: true,
  arrows: false,
  omitEnd: true,
  focus: 'center',
};

export { splideOptions };
